import { graphql } from '../../graphql';

export const getAllCities = graphql(`
  query AllCities {
    cities(filter: { scope: ALL }) {
      id
      name
      slug
      latitude
      longitude
    }
  }
`);

export const getPopularCities = graphql(`
  query PopularCities {
    cities(filter: { scope: POPULAR }, limit: 10) {
      id
      name
      slug
    }
  }
`);
